// extracted by mini-css-extract-plugin
export default {"Nav":"Nav-module__Nav__OwpQ4Z9"};